import React from 'react';

export const isTabVisible = () =>
  typeof document === 'undefined' || document.visibilityState !== 'hidden';

/** Whether this tab is in view, kept current: a tab opened in the background
 * is no visit until someone looks at it. */
const useTabVisible = () => {
  const [visible, setVisible] = React.useState(isTabVisible);
  React.useEffect(() => {
    const onChange = () => setVisible(isTabVisible());
    document.addEventListener('visibilitychange', onChange);
    // A change between the first render and this listener is not lost.
    onChange();
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
  return visible;
};

export default useTabVisible;
